import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

const STEPS = [
    {
        n: "01",
        word: "Clarity",
        body: "A clear story about what you do, for whom, and why it matters.",
    },
    {
        n: "02",
        word: "Trust",
        body: "Every signal — design, words, proof — reinforces the next.",
    },
    {
        n: "03",
        word: "Enquiries",
        body: "The right buyers reach out, already pre-qualified.",
    },
    {
        n: "04",
        word: "Growth",
        body: "Compounding visibility, reputation, and revenue.",
    },
];

export const WhyInfographic = () => {
    return (
        <div data-testid="why-infographic" className="relative w-full">
            {/* Vertical guide line */}
            <svg
                className="absolute left-1/2 top-0 -translate-x-1/2 w-px h-full"
                viewBox="0 0 2 100"
                preserveAspectRatio="none"
            >
                <motion.line
                    x1="1" y1="0" x2="1" y2="100"
                    stroke="rgba(255,255,255,0.25)"
                    strokeWidth="1" strokeDasharray="2 3"
                    initial={{ pathLength: 0 }}
                    whileInView={{ pathLength: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 1.6, ease: EASE }}
                />
            </svg>

            <ul className="relative space-y-8 md:space-y-12">
                {STEPS.map((s, i) => (
                    <motion.li
                        key={s.n}
                        initial={{ opacity: 0, y: 24 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-60px" }}
                        transition={{ duration: 0.9, delay: i * 0.12, ease: EASE }}
                        className={`grid grid-cols-12 items-center gap-6 ${
                            i % 2 === 0 ? "" : "md:[direction:rtl]"
                        }`}
                    >
                        <div className="col-span-5 md:col-span-5 [direction:ltr] text-right md:pr-8">
                            <p className="text-[10px] tracking-[0.28em] uppercase text-white/50">
                                Step {s.n}
                            </p>
                            <h3 className="mt-2 font-serif text-4xl md:text-6xl leading-none">
                                {s.word}
                            </h3>
                        </div>
                        <div className="col-span-2 flex justify-center [direction:ltr]">
                            <div className="relative w-12 h-12 flex items-center justify-center">
                                <span className="absolute inset-0 rounded-full border border-white/30" />
                                <span className="absolute inset-2 rounded-full border border-white/15" />
                                <span className="w-2 h-2 bg-white rounded-full" />
                            </div>
                        </div>
                        <div className="col-span-5 md:col-span-5 [direction:ltr] md:pl-8">
                            <p className="text-white/70 leading-relaxed max-w-xs">
                                {s.body}
                            </p>
                        </div>
                    </motion.li>
                ))}
            </ul>

            {/* Closing arrow */}
            <motion.div
                initial={{ opacity: 0, y: 8 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.9, delay: 0.4, ease: EASE }}
                className="mt-12 flex justify-center"
            >
                <div className="flex flex-col items-center">
                    <span className="w-px h-10 bg-white/40 inline-block" />
                    <span className="-mt-1 text-white">▼</span>
                    <span className="mt-3 font-serif italic text-white/70 text-sm">
                        the system compounds
                    </span>
                </div>
            </motion.div>
        </div>
    );
};
